import React from "react";
import { FutureCEOConfig } from "../../data/futureCEOConfigs";

interface CTAProps {
  config: FutureCEOConfig;
}

const CTA: React.FC<CTAProps> = ({ config }) => {
  return (
    // CTA removed per request (text block excluded)
    <></>
  );
};

export default CTA;
